import { Component, Host, h, Element, Prop } from '@stencil/core';

export interface AhaEmptyState extends HTMLAhaEmptyStateElement {}

/**
 * Custom empty state component with a title, body and actions.
 * @slot default - Contents of the body.
 * @slot title - Contents of the title.
 * @slot actions - Contents of the footer actions.
 * @slot icon - Contents of the icon.
 */
@Component({
  tag: 'aha-empty-state',
  styleUrl: 'aha-empty-state.css',
  shadow: true,
})
export class AhaEmptyState {
  @Element() host!: HTMLAhaEmptyStateElement;

  /** Icon to display in the aha-icon component. */
  @Prop() heading: string = '';

  /** The icon to be shown. This is instead of using the slot. */
  @Prop() icon: string = '';

  render() {
    return (
      <Host>
        {this.icon && (
          <div class="aha-empty-state__icon">
            <aha-icon icon={`${this.icon}`}></aha-icon>
          </div>
        )}
        <slot name="icon"></slot>
        {this.heading && <h2 class="aha-empty-state__title">{this.heading}</h2>}
        <slot name="title"></slot>
        <p id="body">
          <slot></slot>
        </p>
        <slot name="actions"></slot>
      </Host>
    );
  }
}
